import { Controller } from "@hotwired/stimulus";

// 🔴 « Qui joue ? » — les prénoms DITS À VOIX HAUTE (carte #1614, `WF-09`, `DS-04`).
//
// La planche de l'écran 14 : « Savi dit les deux prénoms à voix haute. Rien à lire pour
// choisir. » En maternelle, `DS-04` impose « aucun texte requis » : un enfant de cinq ans
// choisit sur le visage et sur le son, jamais sur le mot écrit.
//
// ⚠️ AUCUN ACTIF, AUCUN RÉSEAU. La synthèse est celle du navigateur. Une narration
// enregistrée demanderait un fichier audio PAR PRÉNOM DE CHAQUE FOYER — c'est-à-dire un
// enregistrement à la demande pour un contenu qui n'est pas du contenu. `T-07` borne la
// page à 250 Ko, et le bundle `learn` est déjà au-dessus.
//
// 🔴 LE HAUT-PARLEUR SE RETIRE LUI-MÊME QUAND LA SYNTHÈSE N'EXISTE PAS — et c'est le
// contraire d'un repli silencieux. Un bouton qui ne fait rien apprend à un enfant que
// toucher l'écran est sans effet, et c'est la leçon qu'on passe le plus de temps à défaire.
// L'absence, elle, ne lui apprend rien.
export default class extends Controller {
  static targets = ["speaker"];
  static values = { names: Array, lang: String };

  connect() {
    if (!this.supported) this.hideSpeaker();
  }

  disconnect() {
    if (this.supported) window.speechSynthesis.cancel();
  }

  // Les prénoms, dans l'ordre des tuiles. On annule d'abord : un enfant qui appuie deux
  // fois doit réentendre depuis le début, jamais empiler deux voix.
  say() {
    if (!this.supported) return;

    window.speechSynthesis.cancel();
    this.namesValue.forEach((name) => {
      const phrase = new SpeechSynthesisUtterance(String(name));
      phrase.lang = this.langValue === "en" ? "en-GB" : "fr-FR";
      // Un enfant de cinq ans suit une élocution posée. La valeur n'a pas de jeton : elle
      // n'appartient pas au design system, elle appartient à la voix.
      phrase.rate = 0.9;
      window.speechSynthesis.speak(phrase);
    });
  }

  get supported() {
    return typeof window !== "undefined" &&
      "speechSynthesis" in window &&
      typeof window.SpeechSynthesisUtterance === "function";
  }

  hideSpeaker() {
    if (this.hasSpeakerTarget) this.speakerTarget.remove();
  }
}
